module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/3_52777e4133a1d738b0cba145c99359d1.png";